export enum SecaoDaIntegracaoNaUrl {
  COLABORADORES = 'colaboradores',
  INFORMACOES = 'informacoes',
  FINALIZAR = 'finalizar',
}
